"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class SignInViaEmailLinkError extends client_library_1.ExtendableError {
    constructor(email, callbackUrl) {
        super(`Internal server error with email: ${email} and callbackUrl: ${callbackUrl}`);
    }
}
exports.default = SignInViaEmailLinkError;
